"use strict";
exports.__esModule = true;
exports.ParserNode = void 0;
var hyper_utils_1 = require("hyper-utils");
var PdfParserFinder_1 = require("./PdfParserFinder");
var ParserNode = /** @class */ (function () {
    function ParserNode(page, node) {
        this.element = node;
        this.page = page;
    }
    ParserNode.prototype.Right = function (options) {
        if (options === void 0) { options = {}; }
        var newNode = new ParserNode(this.page);
        if (this.element) {
            var element = PdfParserFinder_1.PdfParserFinder.FindRightOfElementPage(this.page, this.element, options.index, options.displacement);
            newNode.element = element;
        }
        return newNode;
    };
    ParserNode.prototype.RightTillNumber = function (options) {
        if (options === void 0) { options = {}; }
        var skip = options.skip || 0;
        var current = this.Right(options);
        while (current.element) {
            if (!Number.isNaN(current.MoneyValue())) {
                if (skip === 0) {
                    return current;
                }
                else {
                    skip--;
                }
            }
            current = current.Right(options);
        }
        return current;
    };
    ParserNode.prototype.RightText = function (options) {
        if (options === void 0) { options = {}; }
        var current = this.Right(options);
        while (current.element) {
            if (current.CleanText().trim()) {
                return current;
            }
            current = current.Right(options);
        }
        return current;
    };
    ParserNode.prototype.Left = function (options) {
        if (options === void 0) { options = {}; }
        var newNode = new ParserNode(this.page);
        if (this.element) {
            var element = PdfParserFinder_1.PdfParserFinder.FindLeftOfElementPage(this.page, this.element, options.displacement);
            newNode.element = element;
        }
        return newNode;
    };
    ParserNode.prototype.Up = function (options) {
        if (options === void 0) { options = {}; }
        var newNode = new ParserNode(this.page);
        if (this.element) {
            var element = PdfParserFinder_1.PdfParserFinder.FindUpOfElementPage(this.page, this.element, options.displacement);
            newNode.element = element;
        }
        return newNode;
    };
    ParserNode.prototype.Down = function (options) {
        if (options === void 0) { options = {}; }
        var newNode = new ParserNode(this.page);
        if (this.element) {
            var element = PdfParserFinder_1.PdfParserFinder.FindDownOfElementPage(this.page, this.element, options.displacement);
            newNode.element = element;
        }
        return newNode;
    };
    ParserNode.prototype.DownTillText = function (options) {
        if (options === void 0) { options = {}; }
        var node = this.Down(options);
        while (node.element) {
            if (node.CleanText())
                return node;
            node = node.Down();
        }
        return node;
    };
    ParserNode.prototype.Row = function (options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var nodes = [];
        if (this.element) {
            var element = PdfParserFinder_1.PdfParserFinder.FindRowContainingElementPage(this.page, this.element, options.displacement);
            nodes = element.map(function (item) { return new ParserNode(_this.page, item); });
        }
        return nodes;
    };
    ParserNode.prototype.Column = function (options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var nodes = [];
        if (this.element) {
            var element = PdfParserFinder_1.PdfParserFinder.FindColumnContainingElementPage(this.page, this.element, options.displacement);
            nodes = element.map(function (item) { return new ParserNode(_this.page, item); });
        }
        return nodes;
    };
    ParserNode.prototype.Intersection = function (withNode, options) {
        if (options === void 0) { options = {}; }
        var newNode = new ParserNode(this.page);
        if (this.element && withNode.element) {
            var element = PdfParserFinder_1.PdfParserFinder.FindIntersectionNodeOfPage(this.page, this.element, withNode.element, options.displacementX, options.displacementY);
            // console.log(element, "res");
            newNode.element = element;
        }
        return newNode;
    };
    /** Returns -1 if not exists */
    ParserNode.prototype.X = function () {
        var _a, _b;
        return (_b = (_a = this.element) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : -1;
    };
    /** Returns -1 if not exists */
    ParserNode.prototype.Y = function () {
        var _a, _b;
        return (_b = (_a = this.element) === null || _a === void 0 ? void 0 : _a.y) !== null && _b !== void 0 ? _b : -1;
    };
    // Methods which will return non chainable values.
    ParserNode.prototype.MoneyValue = function (ToFixed) {
        if (ToFixed === void 0) { ToFixed = true; }
        if (!this.element)
            return NaN;
        var val = PdfParserFinder_1.PdfParserFinder.GetMoneyValue(this.element.text);
        if (ToFixed)
            val = hyper_utils_1.CommonUtils.toFixedNumber(val, 2);
        return val;
    };
    ParserNode.prototype.NumberValue = function () {
        if (!this.element)
            return NaN;
        var numberRegex = /[-+]?(\d*\.\d+|\d+)/;
        var match = this.element.text.match(numberRegex);
        return match ? parseFloat(match[0]) : NaN;
    };
    ParserNode.prototype.CleanText = function () {
        if (!this.element)
            return "";
        return this.element.text.trim();
    };
    ParserNode.prototype.Exists = function () {
        return !!this.element;
    };
    return ParserNode;
}());
exports.ParserNode = ParserNode;
//# sourceMappingURL=ParserNode.js.map